"use client";

interface Props {
  x: number;          // SVG x coord
  plotTop: number;
  plotBottom: number;
}

export function HoverCrosshair({ x, plotTop, plotBottom }: Props) {
  return (
    <line
      aria-hidden="true"
      x1={x}
      x2={x}
      y1={plotTop}
      y2={plotBottom}
      stroke="currentColor"
      strokeOpacity={0.25}
      strokeWidth={1}
      strokeDasharray="2 3"
      pointerEvents="none"
    />
  );
}
